import React from "react";
import Cardforwork from "./Cardforwork";

export default function Recentwork() {
  return (
    <div className="container-fluid main">
      {/* <h2 className="rc">~/Recent Projects</h2> */}
      <h5 className="highlightedtext">Highlighted Projects</h5>
      <h3 className="rc">What I've been working on</h3>
      <div className="row">
        {/* Stashly */}
        <div className="col-md-6 col-sm-6">
          <Cardforwork
            title="Stashly - Master Your Money"
            tech="ReactJS, TailwindCSS, Lucide-React, Recharts"
            about="Financial toolkit built to help you track budgets, split expenses with friends."
            imgsrc={require("../assets/project-stashly.webp")}
            weburl="https://stashlytrack.netlify.app/"
            status="operational"
          />
        </div>

        {/* GridMyLife */}
        <div className="col-md-6 col-sm-6">
          <Cardforwork
            title="GridMyLife - Habit Tracker"
            tech="ReactJS, Tailwind, LucideReact"
            about="minimalist, high-performance habit tracker built with React and Tailwind CSS."
            imgsrc={require("../assets/project-habittracker.webp")}
            weburl="https://trackerhabit.vercel.app/"
            status="operational"
          />
        </div>

        {/* ToolsGarage */}
        <div className="col-md-6 col-sm-6">
          <Cardforwork
            title="ToolsGarage"
            tech="ReactJS, Bootstrap, APIs"
            about="Open-Source Toolbox Website Offering a Curated Collection of Web Development Resources and Utilities."
            imgsrc={require("../assets/projects-tools.webp")}
            weburl="https://toolsgarage.vercel.app/"
            status="operational"
          />
        </div>

        {/* Portfolio Template Project */}
        <div className="col-md-6 col-sm-6">
          <Cardforwork
            title="Portfolio Template"
            tech="ReactJS, BootstrapCSS, JSON"
            about="Modern Dark-Themed Portfolio Template for Developers | Built with React | Dynamic JSON-based content."
            imgsrc={require("../assets/project-portfolio.webp")}
            weburl="https://github.com/AnshulGora/portfolio_template_v1"
            status="operational"
          />
        </div>

        {/* Fitness Junction */}
        <div className="col-md-6 col-sm-6">
          <Cardforwork
            title="Fitness Junction"
            tech="ReactJS, Bootstrap, Firebase"
            about="Comprehensive library of exercises catering to all fitness enthusiasts."
            imgsrc={require("../assets/project-fitness.webp")}
            weburl="https://fitnessjunction.netlify.app/"
            status="Building"
          />
        </div>

        {/* <div className="col-sm-4">
          <Cardforwork
            title="The DailyDose"
            tech="ReactJS, News API"
            about="News app, delivering the latest headlines from around the world at your fingertips."
            //imgsrc={require("../assets/P4.png")}
            weburl="https://thedailydose.netlify.app/"
          />
        </div> */}

        {/* <div className="col-md-6 col-sm-6">
          <Cardforwork
            title="Weather App"
            tech="ReactJS, Open-Weather API"
            about="Stay ahead of the weather with this visually appealing weather app !"
            // imgsrc={require("../assets/P5.png")}
            weburl="https://weathervibe.netlify.app/"
          />
        </div> */}

        {/* <div className="col-md-6 col-sm-6">
          <Cardforwork
            title="Trippy Travels"
            tech="ReactJS, User-Inerface"
            about="Travel website, showcasing various destinations and travel packages."
            // imgsrc={require("../assets/P7 travel.png")}
            weburl="https://trippytravels.netlify.app/"
          />
        </div> */}

        {/* <div className="col-md-6 col-sm-6">
          <Cardforwork
            title="MoviesHub"
            tech="ReactJS, MoviesAPI, Context API"
            about="Movie database, search and explore your favorite movies and TV shows."
            // imgsrc={require("../assets/P9.png")}
            weburl="https://movieshubtime.netlify.app/"
          />
        </div> */}
      </div>
    </div>
  );
}
